import React from "react";

interface IProps {
  onSave: () => void;
  onClose: () => void;
}

export const CatalogModalViewHeader = ({ onSave, onClose }: IProps) => {
  return (
    <>
      <div className={"d-flex w-100 px-3 mb-3"}>
        <div className={"flex-grow-1"}></div>
        <button
          type={"submit"}
          className={"btn btn-primary me-2"}
          onClick={onSave}
        >
          <i className="bi bi-bookmark" style={{ paddingRight: "5px" }}></i>
          Save
        </button>
        <button
          type={"button"}
          className={"btn btn-light me-2"}
          onClick={onClose}
        >
          <i className="bi bi-x-circle" style={{ paddingRight: "5px" }}></i>
          Close
        </button>
      </div>
    </>
  );
};
